import { ApiFile } from '@element451-libs/models451';

export function isImgixUrl(url: string): boolean {
  return typeof url === 'string' && url.includes('imgix.net');
}

export function isImgixFile(file: ApiFile): boolean {
  return file && (!!file.imgix || isImgixUrl(file.url));
}
